<template>
  <div class="GeoFencingEvents">
    <geo-fencing-events-modal
      ref="GeoFencingEventsModalRef"
      @emittedRefreshGrid="loadEvents"
      :items="items"
    />
    <a
      class="btn btn-primary add-new mb-6"
      @click="openEditModal(null)"
    >
      <i class="bi bi-plus" /> {{ $t('geoFencingEvents.addButton') }}</a>
    <DxDataGrid
      :ref="dataGridRef"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
      :data-source="data"
      :hover-state-enabled="true"
      :show-borders="true"
      :show-column-lines="true"
    >
      <DxHeaderFilter :visible="true" />
      <DxPaging
        :page-index="0"
        :page-size="25"
      />
      <DxPager
        :allowed-page-sizes="[10, 20, 25]"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
      <DxFilterRow :visible="false" />
      <DxColumnFixing :enabled="true" />
      <DxColumn
        :caption="$t('geoFencingEvents.vehicleRegistration')"
        cell-template="vehicle-cell-template"
      />
      <DxColumn
        :caption="$t('geoFencingEvents.geoFencingName')"
        cell-template="name-cell-template"
      />
      <DxColumn
        :caption="$t('geoFencingEvents.type')"
        cell-template="type-cell-template"
      />
      <DxColumn
        :caption="$t('geoFencingEvents.state')"
        cell-template="state-cell-template"
      />
      <DxColumn
        v-if="adminOrBoss"
        :caption="$t('components.vehicles.dataGrids.edit')"
        type="buttons"
      >
        <DxButton
          :hint="$t('components.vehicles.dataGrids.edit')"
          icon="edit"
          @click="openEditModal"
        />
      </DxColumn>
      <template #vehicle-cell-template="{ data }">
        {{ data.data.registration }}
      </template>
      <template #name-cell-template="{ data }">
        {{ data.data.geoFencingName }}
      </template>
      <template #type-cell-template="{ data }">
        {{
          data.data.typeId === 0 ? $t('geoFencingEvents.typeOut') : $t('geoFencingEvents.typeIn')
        }}
      </template>
      <template #state-cell-template="{ data }">
        {{
          data.data.stateId === 0 ? $t('geoFencingEvents.stateDeactive') : $t('geoFencingEvents.stateActive')
        }}
      </template>
    </DxDataGrid>
  </div>
</template>

<script>
    import {defineComponent} from "vue";
    import {getAllGeoFencingEvents} from '@/crud/geofencing/getters'
    import GeoFencingEventsModal from "@/components/content/_modals/GeoFencingEventsModal.vue";
    import {
      DxButton,
      DxColumn, DxColumnFixing,
      DxDataGrid,
      DxFilterRow,
      DxHeaderFilter,
      DxPager,
      DxPaging
    } from "devextreme-vue/data-grid";
    import {checkIfAdminOrBoss} from "@/utils/tools";
    export default defineComponent({
      name: 'GeoFencingEvents',
      props: ['items'],
      components: {
        DxColumnFixing,
        DxDataGrid,
        DxPaging,
        DxColumn,
        DxPager,
        DxHeaderFilter,
        DxFilterRow,
        DxButton,
        GeoFencingEventsModal
      },
      data() {
        return {
          data: [],
          dataGridRef: 'geoFencingEventsGrid',
          adminOrBoss: false,
        }
      },
      computed: {
        dataGrid() {
          return this.$refs[this.dataGridRef].instance
        }
      },
      methods: {
        loadEvents() {
          getAllGeoFencingEvents().then((response) => {

            while (this.data.length > 0) {
              this.data.pop()
            }

            response.data.forEach((obj) => {
              this.data.push(obj)
            })
            this.dataGrid.refresh()
          })
        },
        openEditModal(data) {
          this.$refs.GeoFencingEventsModalRef.openEditModal(data === null ? data : data.row.data)
        },
      },
      mounted() {
        this.loadEvents()
        this.adminOrBoss = checkIfAdminOrBoss()
      }
    })
</script>
